"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDIT_ATTRIBUTE = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.EDIT_ATTRIBUTE = (0, gql_1.gql)(`
   mutation EditProductLabelValidation(
    $productLabelValidation: EditProductLabelValidationInput!,
    $sort: [ProductTreeNodeRelativeOrderBy!]!
  ) {
    editProductLabelValidation(productLabelValidation: $productLabelValidation) {
      success
      error
      productTreeNode {
        id
        ancestors(first: 100, sort: $sort) {
          edges {
            node {
              ancestor {
                id
              }
            }
          }
        }
      }
    }
  }
`);
